import { useMemo,useEffect } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
  MRT_ActionMenuItem,
  MRT_ToggleDensePaddingButton,
  MRT_ToggleFullScreenButton,
  MRT_ToggleGlobalFilterButton,
  MRT_ToggleFiltersButton,
  MRT_co
} from 'material-react-table';
//import { data, type Person } from './makeData';
import React from 'react';
import { MRT_Localization_FR } from 'material-react-table/locales/fr';
import {
  Box,
  Backdrop,
  Button,
  Container,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from '@mui/material';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Delete from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import LabelOffIcon from '@mui/icons-material/LabelOff';
import CachedIcon from '@mui/icons-material/Cached';
var _props;
type UserDetails = {
  ID:string;
  name: string;
  matiere: string;
  UpdatedAt:string;
  password: string;
  role: string;
  room_id: string;
  nickname: string;
  status: string;
  iplocal: string;
  etablissement: string;
  pass_crypted: string;
  licence: string;
  nb_licence_teacher: string;
  nb_licence_student: string;
  version: string;
  maj: string;
  majv2: string;
  ippublic: string;
  mac: string;
  bios:string;
  code:string;
};
/*Name               string `json:"name"`
	Email              string `json:"email" gorm:"unique"`
	Password           string `json:"password"`
	Role               string `json:"role"`
	Room_id            int    `json:"room_id"`
	Nickname           string `json:"nickname"`
	Status             string `json:"status"`
	Iplocal            string `json:"iplocal"`
	Etablissement      string `json:"etablissement"`
	Id_createur        string `json:"id_createur"`
	Pass_crypted       string `json:"pass_crypted"`
	Licence            string `json:"licence"`
	Nb_Licence_teacher string `json:"nb_licence_teacher"`
	Nb_Licence_student string `json:"nb_licence_student"`
	Version            string `json:"version"`
	Maj                string `json:"maj"`
	Ippublic           string `json:"ippublic"`
	Mac                string `json:"mac"`
*/



const openDeleteConfirmModal = (row: MRT_ColumnDef<UserDetails>) => {
  if (window.confirm('êtes-vous sûr de vouloir effacer le client ' + row.original.name + '?')) {
    console.log(row.original.id);
    console.log(row.original.name);
  }
};
const setWakeOnLan= (row: MRT_ColumnDef<UserDetails>) => {
  if (window.confirm('êtes-vous sûr de vouloir démarrer le poste ' + row.original.name + '?')) {
    console.log(row.original.mac);
    console.log(row.original.name);
    if(_props.socketlabtice!=undefined) _props.socketlabtice.send("demarrerpcwake"+row.original.mac);
    else alert("Pas de connexion avec Labtice");
  }
};
const handleChangeSalle2 = (event,id) => {
  console.log(event.target.value);
  console.log("id du poste:"+id);
  _props.handleChangeSalle(event,id);
};
const CardTableUsers = (props) => {
  const [data, setData] = React.useState([]);
  const [salles, setSalles] = React.useState([]);
  const [labticeversionnum, setLabticeversionnum] = React.useState([]);
  useEffect(() => {
    _props=props;
    console.log(props);
    if(props.dataclientdetails!=data)
    {
      setData([]);
      setTimeout((ev)=>setData(props.dataclientdetails),500);
    }
   
    setLabticeversionnum(props.labticeversion.version);
    if(props.salles!=salles)
    { 
      setSalles(props.salles);
      //setData([]);
      //setTimeout((ev)=>setData(props.dataclientdetails),500)
    }

  }, [props]);
  
  //var data: UserDetails[] = props.dataclientdetails;
  const columns = useMemo<MRT_ColumnDef<UserDetails>[]>(
    () => [
      {
        accessorKey: 'ID',
        header: 'ID',
      },
      {
        accessorKey: 'name',
        header: 'Nom du pc',
      },
      {
        accessorKey: 'matiere',
        header: 'Salle',
        Cell: ({ cell }) => (
          <div>
          <select name={cell.row.original.code}
          onChange={async (ev)=>{var odata=await _props.handleChangeSalle(ev,cell.row.original.ID,_props.dataclientdetails,_props.salles);setData(odata);}}
          defaultValue={cell.getValue<string>()}
          value={cell.row.original.code}
          >
          {props.salles.map((its)=>
            <option value={its.code}>{its.matiere}</option>
            )}
          
        </select>
        </div>
        )
        
      },
      //column definitions...
      {
        accessorKey: 'etablissement',
        header: 'Etablissement',
      },
      {
        accessorKey: 'UpdatedAt',
        header: 'date cnx',
      },
      {
        accessorKey: 'iplocal',
        header: 'IP',
      },
      {
        accessorKey: 'code',
        header: 'Code de la salle',
      },
      {
        accessorKey: 'version',
        header: 'version',
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={(theme) => ({
              backgroundColor:
                cell.getValue<string>() ==props.labticeversion.version
                  ? theme.palette.success.dark
                  : theme.palette.warning.dark,
              borderRadius: '0.25rem',
              color: '#fff',
              maxWidth: '9ch',
              p: '0.25rem',
            })}
          >
            {cell.getValue<number>()?.toLocaleString?.('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })}
          </Box>
        ),
      },
      {
        accessorKey: 'majv2',
        header: 'maj',
        size: 50,
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={(theme) => ({
              backgroundColor:
                cell.getValue<string>() =="oui"
                  ? theme.palette.error.dark
                  : theme.palette.primary.dark,
              borderRadius: '0.25rem',
              color: '#fff',
              maxWidth: '9ch',
              p: '0.25rem',
            })}
          >
            {cell.getValue<number>()?.toLocaleString?.('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })}
          </Box>
        ),
      },
      {
        accessorKey: 'email',
        header: 'identifiant',
      },
      {
        accessorKey: 'licence',
        // enableColumnOrdering: false, //disable column ordering for this column,
        header: 'licence',
      },
      {
        accessorKey: 'nickname',
        header: 'nickname',
      },
      {
        accessorKey: 'mac',
        header: 'mac',
      },
      {
        accessorKey: 'bios',
        header: 'Bios num série',
      },
      {
        accessorKey: 'ippublic',
        header: 'ippublic',
      },
      {
        accessorKey: 'password',
        header: 'password',
      },
      {
        accessorKey: 'nb_licence_teacher',
        header: 'nb_licence_teacher',
      },
    ],
    [],
  );
  const [rowSelection, setRowSelection] = React.useState([]);
  function countSelection(obj){
    var c= 0;
    for(var p in obj) if(obj.hasOwnProperty(p))++c;
    return c;
  } 
  async function setMaj(id, value) {

    var stvalue = value;
    //if (value== "mettreajour") stvalue = "mettreajour"
    const response = await fetch('/api/public/setmajbyid?id_user=' + id + "&valeur=" + stvalue);
  }
  var table = useMaterialReactTable({
    columns,
    data,
    enableEditing: true,
    enableColumnPinning: true,
    enableRowActions: true,
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    state: { rowSelection },
    enableColumnOrdering: true,
    localization: MRT_Localization_FR,
    initialState: { columnPinning: { left: ['mrt-row-select','mrt-row-actions'] },pagination: { pageSize: 100, pageIndex: 0 } , columnVisibility: {ID:false, etablissement: false, nickname: false, nb_licence_teacher: false ,password:false,bios:false,ippublic:false,email:false} },
    renderRowActionMenuItems:({ closeMenu,row, table }) => [
      
      <MRT_ActionMenuItem
        icon={<PowerSettingsNewIcon />}
        key="wakeup"
        label="Démarrer le poste"
        onClick={() =>{closeMenu();setWakeOnLan(row);}}
        table={table}
      />,
      <MRT_ActionMenuItem
        icon={<LocalOfferIcon />}
        key="licenceauto"
        label="Affecter une licence enseignante"
        disabled={row.original.licence!=""}
        onClick={() =>{closeMenu();_props.setAutoLogin(row.original.ID,true);}}
        table={table}
      />,
      <MRT_ActionMenuItem
        icon={<LabelOffIcon />}
        key="licenceremove"
        label="Supprimer une licence enseignante"
        disabled={row.original.licence==""}
        onClick={() =>{closeMenu();_props.setAutoLogin(row.original.ID,false);}}
        table={table}
      />,
      <MRT_ActionMenuItem
        icon={<DeleteIcon />}
        key="delete"
        label="Supprimer ce poste et sa licence"
        onClick={() => {closeMenu();_props.setAutoDelete(row.original.ID); console.info('Delete');}}
        table={table}
      />,
    ],
   /* renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Editer">
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Démarrer le poste">
          <IconButton onClick={() => setWakeOnLan(row)}>
            <PowerSettingsNewIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Effacer">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),*/
    positionToolbarAlertBanner: 'bottom',
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <Box sx={{ display: 'flex', gap: '16px', padding: '4px' }}>
        <IconButton onClick={() => {_props.refresh(null) }}>
          <CachedIcon />   
        </IconButton>
        <Button sx={{ display: countSelection(rowSelection)>0?'flex':'none'}}  color="success"
          onClick={() => {
            //const lrowSelection = table.getState().rowSelection; //read state
            const lselectedRows = table.getSelectedRowModel().rows; //or read entire rows
            var sttabmac="";
            lselectedRows.map((it)=>
            {
              //console.log(lselectedRows.original.mac);
              sttabmac+=it.original.mac+"*";
            });
            if(_props.socketlabtice!=undefined) 
            {
              _props.socketlabtice.send("demarrerpcwake"+sttabmac);
              alert("L'ordre de démarrage a été envoyé");
            }
            else alert("Pas de connexion avec Labtice");
            
          }}
          variant="contained"
        >
           <PowerSettingsNewIcon />
           Démarrer le(s) poste(s)
        </Button>
        <Button sx={{ display: countSelection(rowSelection)>0?'flex':'none'}}  color="error"
           onClick={() => {
            //const lrowSelection = table.getState().rowSelection; //read state
            const lselectedRows = table.getSelectedRowModel().rows; //or read entire rows
            var obj=props.dataclientdetails;
            setData([]);
            lselectedRows.map((it)=>
            {
              console.log(it.original.ID); 
              setMaj(it.original.ID,"mettreajour")
              obj.map((it2)=>{if (it2.ID==it.original.ID){it2.maj="mettreajour";it2.majv2="oui";}});
              //sttabmac+=it.original.mac+"*";
            });
            setTimeout((ev)=>_props.refresh(obj),200);
            
            
          }}
          variant="contained"
        >
           Activer la mise à jour 
        </Button>
        <Button sx={{ display: countSelection(rowSelection)>0?'flex':'none'}}  color="primary"
           onClick={() => {
            //const lrowSelection = table.getState().rowSelection; //read state
            const lselectedRows = table.getSelectedRowModel().rows; //or read entire rows
            var obj=props.dataclientdetails;
            setData([]);
            lselectedRows.map((it)=>
            {
              console.log(it.original.ID); 
              setMaj(it.original.ID,"")
              obj.map((it2)=>{if (it2.ID==it.original.ID){it2.maj="";it2.majv2="non";}});
              //sttabmac+=it.original.mac+"*";
            });
            setTimeout((ev)=>_props.refresh(obj),200);
            
          }}
          variant="contained"
        >
           Désactiver mise à jour 
        </Button>
      </Box>
    ),
  });

  return <MaterialReactTable table={table} />;
};

export default CardTableUsers;
